(() => {
  'use strict';

  const roots = [...document.querySelectorAll('[data-product-section]')];
  if (!roots.length) return;

  const measurements = {
    regular_xs: [
      ['Thumb', '3', '19.7', '14'],
      ['Index', '8', '17', '10'],
      ['Middle', '7', '17.5', '11'],
      ['Ring', '8', '17', '10'],
      ['Pinky', '11', '14.2', '8']
    ],
    regular_s: [
      ['Thumb', '2', '20', '15'],
      ['Index', '7', '17.5', '11'],
      ['Middle', '6', '18.4', '12'],
      ['Ring', '7', '17.5', '11'],
      ['Pinky', '10', '15', '9']
    ],
    regular_m: [
      ['Thumb', '1', '20.3', '16'],
      ['Index', '6', '18.4', '12'],
      ['Middle', '5', '19', '13'],
      ['Ring', '6', '18.4', '12'],
      ['Pinky', '9', '16', '10']
    ],
    regular_l: [
      ['Thumb', '0', '20.6', '17'],
      ['Index', '5', '19', '13'],
      ['Middle', '4', '19.5', '14'],
      ['Ring', '5', '19', '13'],
      ['Pinky', '8', '17', '10']
    ],
    navratri_s: [
      ['Thumb', '2', '20', '12'],
      ['Index', '7', '19', '10'],
      ['Middle', '5', '20', '11.9'],
      ['Ring', '6', '19', '10.5'],
      ['Pinky', '11', '17', '8.5']
    ],
    navratri_m: [
      ['Thumb', '2', '30', '13'],
      ['Index', '6', '26', '9'],
      ['Middle', '8', '24', '8'],
      ['Ring', '7', '25', '9'],
      ['Pinky', '9', '23', '8']
    ],
    medium_almond_xs: [
      ['Thumb', '3', '22', '10'],
      ['Index', '8', '19', '7'],
      ['Middle', '7', '19.5', '7.5'],
      ['Ring', '8', '19', '7'],
      ['Pinky', '9', '18', '6.5']
    ],
    medium_almond_s: [
      ['Thumb', '2', '23', '11.5'],
      ['Index', '7', '19.5', '7.5'],
      ['Middle', '6', '20', '8.5'],
      ['Ring', '7', '19.5', '7.5'],
      ['Pinky', '9', '18', '6.5']
    ],
    medium_almond_m: [
      ['Thumb', '1', '23.5', '12.5'],
      ['Index', '6', '20', '8.5'],
      ['Middle', '5', '20.5', '9'],
      ['Ring', '6', '20', '8.5'],
      ['Pinky', '9', '18', '6.5']
    ],
    medium_almond_l: [
      ['Thumb', '0', '24', '13.5'],
      ['Index', '5', '20.5', '9'],
      ['Middle', '4', '21', '9.5'],
      ['Ring', '5', '20.5', '9'],
      ['Pinky', '8', '19', '7']
    ]
  };

  const variantMap = {
    // Blush Ribbon
    '59625066692894': ['regular_xs', 'Extra Small'],
    '59625066725662': ['regular_s', 'Small'],
    '59625066758430': ['regular_m', 'Medium'],
    '59625066791198': ['regular_l', 'Large'],

    // French Petal
    '59892865335582': ['regular_xs', 'Extra Small'],
    '59892865368350': ['regular_s', 'Small'],
    '59892865401118': ['regular_m', 'Medium'],
    '59892865433886': ['regular_l', 'Large'],

    // Malibu Mood
    '59625067905310': ['regular_xs', 'Extra Small'],
    '59625067938078': ['regular_s', 'Small'],
    '59625067970846': ['regular_m', 'Medium'],
    '59625068003614': ['regular_l', 'Large'],

    // Garba Girl
    '59640354603294': ['navratri_s', 'Small'],
    '59640354636062': ['navratri_m', 'Medium'],

    // Raas Rani
    '59640354701598': ['navratri_s', 'Small'],
    '59640354734366': ['navratri_m', 'Medium'],

    // Polki, Short Almond
    '59625073017118': ['regular_xs', 'Short Almond / Extra Small'],
    '59625073049886': ['regular_s', 'Short Almond / Small'],
    '59625073082654': ['regular_m', 'Short Almond / Medium'],
    '59625073115422': ['regular_l', 'Short Almond / Large'],

    // Polki, Medium Almond
    '59625073148190': ['medium_almond_xs', 'Medium Almond / Extra Small'],
    '59625073180958': ['medium_almond_s', 'Medium Almond / Small'],
    '59625073213726': ['medium_almond_m', 'Medium Almond / Medium'],
    '59625073246494': ['medium_almond_l', 'Medium Almond / Large']
  };

  const escapeHTML = (value) => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const renderRows = (rows) => rows.map(([finger, tip, length, width]) => `
    <tr>
      <th scope="row">${escapeHTML(finger)}</th>
      <td>${escapeHTML(tip)}</td>
      <td>${escapeHTML(length)} mm</td>
      <td>${escapeHTML(width)} mm</td>
    </tr>`).join('');

  roots.forEach((root) => {
    const dialog = root.querySelector('[data-size-dialog]');
    const worksheet = dialog?.querySelector('.size-dialog__table-wrap');
    if (!dialog || !worksheet || dialog.querySelector('[data-pressd-size-chart]')) return;

    const selectedChart = document.createElement('section');
    selectedChart.className = 'pressd-size-chart';
    selectedChart.dataset.pressdSizeChart = '';
    selectedChart.setAttribute('aria-live', 'polite');
    worksheet.before(selectedChart);
    worksheet.remove();

    const updateChart = () => {
      const variantId = String(root.dataset.currentVariantId || '').replace(/\D/g, '');
      const mapping = variantMap[variantId];

      if (!mapping || !measurements[mapping[0]]) {
        selectedChart.hidden = true;
        return;
      }

      const [measurementKey, label] = mapping;
      selectedChart.hidden = false;
      selectedChart.innerHTML = `
        <div class="pressd-size-chart__heading">
          <div>
            <p class="eyebrow">Your selected Pressd size</p>
            <h3>${escapeHTML(label)}</h3>
          </div>
          <span>Measurements in mm</span>
        </div>
        <p class="pressd-size-chart__intro">Use the width as the main fit check. The tip number, length and width below match the selected set.</p>
        <div class="pressd-size-chart__table-wrap">
          <table>
            <caption class="visually-hidden">Measurements for ${escapeHTML(label)}</caption>
            <thead>
              <tr>
                <th scope="col">Finger</th>
                <th scope="col">Tip</th>
                <th scope="col">Length</th>
                <th scope="col">Width</th>
              </tr>
            </thead>
            <tbody>${renderRows(measurements[measurementKey])}</tbody>
          </table>
        </div>`;
    };

    root.addEventListener('pressd:variant-change', updateChart);
    root.querySelectorAll('[data-open-size-guide]').forEach((button) => {
      button.addEventListener('click', updateChart);
    });

    updateChart();
  });
})();
